var e = "undefined" != typeof ArrayBuffer && "undefined" != typeof DataView;
export { e as a };